export default "__VITE_ASSET__CNFKPmV4__"